var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-mush-list",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goDailyPushList.apply(null, arguments);
      }
    }
  }, [_vm.isPromoter == 1 ? _c('ycf-image', {
    staticClass: "img-back",
    attrs: {
      "src": "/srcv2/images/mush_list_bitui_bg.png"
    }
  }) : _vm._e(), _vm.isPromoter == 0 ? _c('ycf-image', {
    staticClass: "img-back",
    attrs: {
      "src": "/srcv2/images/mush_list_bimai_bg.png"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "rank-content"
  }, [_c('div', {
    staticClass: "rank-icon"
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/mush_list_rank_icon.png"
    }
  }), _c('span', {
    class: {
      'over-10': _vm.ranking >= 10
    }
  }, [_vm._v(_vm._s(_vm.ranking))])], 1), _c('div', {
    staticClass: "rank-txt"
  }, [_vm._v("今日" + _vm._s(_vm.isPromoter ? "必推" : "必买") + "榜第"), _c('i', [_vm._v(_vm._s(_vm.ranking))]), _vm._v("名")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };